<template>
  <div class="stock-customers-page">
    <!-- 横幅 -->
    <section class="hero-banner">
      <div class="banner-content">
        <div class="text-content">
          <h1 class="brand-name">红土证券</h1>
          <h2 class="main-title">股票客户</h2>
          <a :href="resolveLink(externalLinks.openAccount)" target="_blank" rel="noopener noreferrer" class="cta-button">立即开户</a>
        </div>
      </div>
    </section>


    <!-- 优势 -->
    <section class="longbridge-advantages py-16 bg-white">
      <div class="max-w-7xl mx-auto px-4 lg:px-8">
        <div class="text-center mb-12">
          <h2 class="text-3xl lg:text-4xl font-bold text-gray-900">红土证券优势</h2>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12">
          <div class="advantage-card flex items-start space-x-4">
            <div class="icon-container">
              <img src="/assets/bz1.png" alt="低费率">
            </div>
            <div class="flex-1">
              <p class="text-gray-900 text-base leading-relaxed">极低佣金，让客户轻松交易无负担</p>
            </div>
          </div>
          <div class="advantage-card flex items-start space-x-4">
            <div class="icon-container">
              <img src="/assets/bz2.png" alt="专业工具">
            </div>
            <div class="flex-1">
              <p class="text-gray-900 text-base leading-relaxed">领先一代的技术和先进的交易工具可以从和任何桌面或移动设备轻松交易和管理财富资产</p>
            </div>
          </div>
          <div class="advantage-card flex items-start space-x-4">
            <div class="icon-container">
              <img src="/assets/bz3.png" class="w-13 h-13" alt="广泛市场">
            </div>
            <div class="flex-1">
              <p class="text-gray-900 text-base leading-relaxed">一个账户，让客户从港股、美股市场自由交易</p>
            </div>
          </div>
          <div class="advantage-card flex items-start space-x-4">
            <div class="icon-container">
              <img src="/assets/bz4.png" alt="便捷出入金">
            </div>
            <div class="flex-1">
              <p class="text-gray-900 text-base leading-relaxed">支持丰富的出入金方式，流畅客户体验</p>
            </div>
          </div>
          <div class="advantage-card flex items-start space-x-4">
            <div class="icon-container">
              <img src="/assets/bz5.png" alt="个性化服务">
            </div>
            <div class="flex-1">
              <p class="text-gray-900 text-base leading-relaxed">独家风控体系，让客户一手识别异动情况</p>
            </div>
          </div>
          <div class="advantage-card flex items-start space-x-4">
            <div class="icon-container">
              <img src="/assets/bz5.png" alt="安全保障">
            </div>
            <div class="flex-1">
              <p class="text-gray-900 text-base leading-relaxed">资深业务团队，给客户以最好的行情解析</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 专享特权 -->
    <section class="exclusive-privileges py-16 bg-gray-50">
      <div class="max-w-7xl mx-auto px-4 lg:px-8">
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div class="privilege-cards">
            <img src="@/assets/eb285a4109fc4c517f02d5a626d0cb5d.jpg" alt="股票客户特权">
          </div>
          <div class="text-content">
            <h3 class="text-3xl font-bold text-gray-900 mb-6">股票客户专享特权</h3>
            <ul class="space-y-4 mb-6">
              <li class="flex items-start">
                <span class="w-2 h-2 bg-[#ef7c5b] rounded-full mt-2 mr-3 flex-shrink-0"></span>
                <span class="text-gray-700 leading-relaxed">股票客户专享特权</span>
              </li>
              <li class="flex items-start">
                <span class="w-2 h-2 bg-[#ef7c5b] rounded-full mt-2 mr-3 flex-shrink-0"></span>
                <span class="text-gray-700 leading-relaxed">满怀诚意的费率定价</span>
              </li>
              <li class="flex items-start">
                <span class="w-2 h-2 bg-[#ef7c5b] rounded-full mt-2 mr-3 flex-shrink-0"></span>
                <span class="text-gray-700 leading-relaxed">低门槛、低费用</span>
              </li>
              <li class="flex items-start">
                <span class="w-2 h-2 bg-[#ef7c5b] rounded-full mt-2 mr-3 flex-shrink-0"></span>
                <span class="text-gray-700 leading-relaxed">美股、港股低佣金，开户即享多重权益</span>
              </li>
              <li class="flex items-start">
                <span class="w-2 h-2 bg-[#ef7c5b] rounded-full mt-2 mr-3 flex-shrink-0"></span>
                <span class="text-gray-700 leading-relaxed">更灵活性的购买力</span>
              </li>
            </ul>
            <div class="highlight-box p-4 pl-0 mb-6">
              <p class="text-[#ef7c5b] font-semibold text-lg">即刻开户，即刻体验</p>
            </div>
            <a :href="resolveLink(externalLinks.learnMore)" target="_blank" rel="noopener noreferrer" class="bg-[#ef7c5b] cursor-pointer inline-block text-white px-8 py-2 rounded-3xl font-semibold transition-colors">
              了解详情
            </a>
          </div>
        </div>
      </div>
    </section>

    <!-- 投资者工具 -->
    <section class="investor-tools py-16 bg-white">
      <div class="max-w-7xl mx-auto px-4 lg:px-8">
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div class="text-content">
            <h3 class="text-3xl font-bold text-gray-900 mb-6">专业投资者工具</h3>
            <ul class="space-y-6">
              <li class="flex items-start">
                <span class="w-3 h-3 bg-orange-500 rounded-full mt-2 mr-4 flex-shrink-0"></span>
                <div>
                  <p class="text-gray-900 font-semibold mb-1">智能选股</p>
                  <p class="text-gray-700 leading-relaxed">多维度因子筛选，结合主题与行业景气度</p>
                </div>
              </li>
              <li class="flex items-start">
                <span class="w-3 h-3 bg-orange-500 rounded-full mt-2 mr-4 flex-shrink-0"></span>
                <div>
                  <p class="text-gray-900 font-semibold mb-1">交易风控</p>
                  <p class="text-gray-700 leading-relaxed">下单前后风控提示，支持价格提醒与止盈止损</p>
                </div>
              </li>
              <li class="flex items-start">
                <span class="w-3 h-3 bg-orange-500 rounded-full mt-2 mr-4 flex-shrink-0"></span>
                <div>
                  <p class="text-gray-900 font-semibold mb-1">投资报告</p>
                  <p class="text-gray-700 leading-relaxed">周期性持仓分析与收益归因，辅助策略优化</p>
                </div>
              </li>
            </ul>
            <a :href="resolveLink(externalLinks.investorTools)" target="_blank" rel="noopener noreferrer" class="bg-[#ef7c5b] cursor-pointer inline-block text-white px-8 py-2 mt-4 rounded-3xl font-semibold transition-colors">
              了解详情
            </a>
          </div>
          <div class="phone-showcase flex justify-center">
            <img src="@/assets/512b49715c3cd53ac4f12cd6a1560aaf.jpg" alt="工具展示">
          </div>
        </div>
      </div>
    </section>
   <!-- 领先一代的技术 -->
    <section class="tech-advantages py-16 bg-white">
      <div class="max-w-7xl mx-auto px-4 lg:px-8">
        <div class="mb-6">
          <h2 class="text-3xl lg:text-4xl font-bold text-gray-900">领先一代的技术</h2>
          <p class="text-base text-gray-800 mt-2">首创云原生架构，提高交易稳定性，实时计算综合购买力、更新账户资产和实时账户风险提示</p>
        </div>

        <div class="flex gap-6 mb-6 items-center text-gray-600">
          <button v-for="tab in techTabs" :key="tab.key" class="nav-tab" :class="{ active: currentTechTab===tab.key }" @click="currentTechTab=tab.key">{{ tab.label }}</button>
        </div>
        <div class="border-b border-gray-200 mb-8"></div>

        <div class="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
          <div class="tech-card">
            <div class="tech-card-body">
              <div class="tech-title">{{ currentTech.cardLeft.title }}</div>
              <div class="tech-subtitle">{{ currentTech.cardLeft.subtitle }}</div>
            </div>
          </div>
          <div class="tech-card">
            <div class="tech-card-body">
              <div class="tech-title">{{ currentTech.cardRight.title }}</div>
              <div class="tech-subtitle">{{ currentTech.cardRight.subtitle }}</div>
            </div>
          </div>
        </div>

        <p class="text-gray-800 mb-4">{{ currentTech.intro }}</p>

        <ul class="space-y-6 mb-8">
          <li v-for="(adv, idx) in currentTech.advantages" :key="idx" class="flex items-start">
            <span class="advantage-icon-box">
              <svg class="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="#ef7c5b" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle v-if="idx===0" cx="12" cy="12" r="3"/>
                <path v-if="idx===0" d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 11-2.83 2.83l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 11-4 0v-.09A1.65 1.65 0 009.4 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 11-2.83-2.83l.06-.06a1.65 1.65 0 00.33-1.82 1.65 1.65 0 01-1.51-1H3a2 2 0 110-4h.09A1.65 1.65 0 004.6 9.4a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 112.83-2.83l.06.06a1.65 1.65 0 001.82.33H9a1.65 1.65 0 001-1.51V3a2 2 0 114 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 112.83 2.83l-.06.06a1.65 1.65 0 00-.33 1.82V9a1.65 1.65 0 001.51 1H21a2 2 0 110 4h-.09a1.65 1.65 0 00-1.51 1z"/>
                <path v-if="idx===1" d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                <template v-if="idx===2">
                  <rect x="3" y="3" width="18" height="14" rx="2" ry="2"/>
                  <path d="M7 19h10M9 7l2 2 4-4"/>
                </template>
              </svg>
            </span>
            <span class="text-gray-800">{{ adv }}</span>
          </li>
        </ul>

        <div class="text-center">
          <a :href="resolveLink(externalLinks.techLearnMore)" target="_blank" rel="noopener noreferrer" class="learn-more-btn inline-block">了解更多</a>
        </div>

        <div class="mt-8 text-center text-gray-500">值得信赖的证券经纪服务商</div>
      </div>
    </section>
    <!-- 交易能力 -->
    <section class="trading-capabilities py-16 bg-gray-50">
      <div class="max-w-7xl mx-auto px-4 lg:px-8">
        <div class="text-center mb-12">
          <h2 class="text-3xl lg:text-4xl font-bold text-gray-900">全面的股票交易服务</h2>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          <div class="capability-card bg-white rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow">
            <div class="flex items-start gap-4">
              <img src="/assets/khb1.png" class="w-13 h-13" alt="全终端覆盖">
              <div class="flex-1">
                <h3 class="text-xl font-semibold text-gray-900 mb-2">全终端覆盖</h3>
                <ul class="text-gray-700 space-y-1 text-sm">
                  <li>• 桌面端、移动端一致体验</li>
                  <li>• 随时随地下单与查看行情</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="capability-card bg-white rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow">
            <div class="flex items-start gap-4">
              <img src="/assets/khb2.png" class="w-13 h-13" alt="多市场覆盖">
              <div class="flex-1">
                <h3 class="text-xl font-semibold text-gray-900 mb-2">多市场覆盖</h3>
                <ul class="text-gray-700 space-y-1 text-sm">
                  <li>• 港股、美股、A股等</li>
                  <li>• 支持多品种交易</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="capability-card bg-white rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow">
            <div class="flex items-start gap-4">
              <img src="/assets/khb3.png" class="w-13 h-13" alt="实时监控">
              <div class="flex-1">
                <h3 class="text-xl font-semibold text-gray-900 mb-2">实时监控</h3>
                <ul class="text-gray-700 space-y-1 text-sm">
                  <li>• 市场动态与事件提醒</li>
                  <li>• 把握交易机会</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="capability-card bg-white rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow">
            <div class="flex items-start gap-4">
              <img src="/assets/khb4.png" class="w-13 h-13" alt="专业研究支持">
              <div class="flex-1">
                <h3 class="text-xl font-semibold text-gray-900 mb-2">专业研究支持</h3>
                <ul class="text-gray-700 space-y-1 text-sm">
                  <li>• 资深研究团队深度分析</li>
                  <li>• 策略与选股建议</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="capability-card bg-white rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow">
            <div class="flex items-start gap-4">
              <img src="/assets/khb5.png" class="w-13 h-13" alt="风控保障">
              <div class="flex-1">
                <h3 class="text-xl font-semibold text-gray-900 mb-2">风控保障</h3>
                <ul class="text-gray-700 space-y-1 text-sm">
                  <li>• 多维风险识别与预警</li>
                  <li>• 持仓与资金安全保护</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="capability-card bg-white rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow">
            <div class="flex items-start gap-4">
              <img src="/assets/khb5.png" class="w-13 h-13" alt="合规保障">
              <div class="flex-1">
                <h3 class="text-xl font-semibold text-gray-900 mb-2">合规保障</h3>
                <ul class="text-gray-700 space-y-1 text-sm">
                  <li>• 严格合规流程</li>
                  <li>• 审计追踪与隐私保护</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 值得信赖 -->
    <section class="trusted-broker py-16 bg-gray-50">
      <div class="max-w-7xl mx-auto px-4 lg:px-8">
        <div class="text-center mb-6">
          <h2 class="text-3xl lg:text-4xl font-bold text-gray-900">值得信赖的证券经纪服务商</h2>
          <p class="text-base text-gray-800 max-w-3xl mx-auto mt-3">
            专业、合规、安全的服务体系，为您的股票投资保驾护航
          </p>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8">
          <div class="service-card bg-white rounded-lg p-6 shadow-sm">
            <div class="icon-top flex items-center justify-center mb-4">
              <img src="/assets/zh11.png" alt="资产安全保障">
            </div>
            <h4 class="text-lg font-semibold text-gray-900 mb-3 text-center">资产安全保障</h4>
            <ul class="text-gray-700 list-none space-y-3">
              <li class="flex items-start"><span class="w-2 h-2 bg-black rounded-full mt-2 mr-3 flex-shrink-0"></span><span>客户资产独立托管</span></li>
              <li class="flex items-start"><span class="w-2 h-2 bg-black rounded-full mt-2 mr-3 flex-shrink-0"></span><span>严格风控审核</span></li>
              <li class="flex items-start"><span class="w-2 h-2 bg-black rounded-full mt-2 mr-3 flex-shrink-0"></span><span>多重安全防护</span></li>
            </ul>
          </div>
          <div class="service-card bg-white rounded-lg p-6 shadow-sm">
            <div class="icon-top flex items-center justify-center mb-4">
              <img src="/assets/zh22.png" alt="数据安全与隐私">
            </div>
            <h4 class="text-lg font-semibold text-gray-900 mb-3 text-center">数据安全与隐私</h4>
            <ul class="text-gray-700 list-none space-y-3">
              <li class="flex items-start"><span class="w-2 h-2 bg-black rounded-full mt-2 mr-3 flex-shrink-0"></span><span>加密传输与存储</span></li>
              <li class="flex items-start"><span class="w-2 h-2 bg-black rounded-full mt-2 mr-3 flex-shrink-0"></span><span>严格隐私保护政策</span></li>
            </ul>
          </div>
          <div class="service-card bg-white rounded-lg p-6 shadow-sm">
            <div class="icon-top flex items-center justify-center mb-4">
              <img src="/assets/zh33.png" alt="专业服务团队">
            </div>
            <h4 class="text-lg font-semibold text-gray-900 mb-3 text-center">专业服务团队</h4>
            <ul class="text-gray-700 list-none space-y-3">
              <li class="flex items-start"><span class="w-2 h-2 bg-black rounded-full mt-2 mr-3 flex-shrink-0"></span><span>资深投顾与客服支持</span></li>
              <li class="flex items-start"><span class="w-2 h-2 bg-black rounded-full mt-2 mr-3 flex-shrink-0"></span><span>7×24小时客户服务</span></li>
              <li class="flex items-start"><span class="w-2 h-2 bg-black rounded-full mt-2 mr-3 flex-shrink-0"></span><span>个性化策略建议</span></li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <!-- 支持账户类型 -->
    <section class="account-types py-16 bg-white">
      <div class="max-w-7xl mx-auto px-4 lg:px-8 text-center">
        <h2 class="text-3xl lg:text-4xl font-bold text-gray-900 mb-3">支持账户类型</h2>
        <p class="text-base text-gray-800 mb-8">个人与机构均可开立股票账户</p>
        <div class="flex items-center justify-center gap-12 mb-6">
          <div class="flex flex-col items-center">
            <img src="/assets/khd2.png" alt="个人账户">
            <div class="text-gray-900">个人账户</div>
          </div>
          <div class="flex flex-col items-center">
            <img src="/assets/khd2.png" alt="机构账户">
            <div class="text-gray-900">机构账户</div>
          </div>
        </div>
        <div class="max-w-3xl mx-auto border border-gray-200 rounded-lg p-6 bg-white text-left">
          <h4 class="font-semibold text-gray-900 mb-2">开立机构账户</h4>
          <p class="text-gray-700 text-sm leading-relaxed">
            机构账户提供更丰富的交易工具与更灵活的服务。如需开立机构账户，请联系客户经理。
          </p>
        </div>
      </div>
    </section>
  </div>
  </template>

<script>
export default {
  name: 'StockCustomers',
  metaInfo: {
    title: '股票客户 - 红土证券'
  },
  data() {
    return {
      defaultTradingUrl: 'https://redland.trade.wbrks.com/Webtrading',
      // 外部链接配置 - 留空时默认跳转交易页
      externalLinks: {
        openAccount: 'https://redland.trade.wbrks.com/Webtrading', // 立即开户按钮
        learnMore: 'https://redland.trade.wbrks.com/Webtrading', // 股票客户专享特权 - 了解详情
        investorTools: 'https://redland.trade.wbrks.com/Webtrading', // 专业投资者工具 - 了解详情
        techLearnMore: 'https://redland.trade.wbrks.com/Webtrading' // 领先一代的技术 - 了解更多
      },
      currentTechTab: 'cloud',
      techTabs: [
        { key: 'cloud', label: '极致用户体验' },
        { key: 'order', label: '一站全球配置' },
        { key: 'market', label: '稳定系统支撑' },
        { key: 'funds', label: '清晰的市场视角' }
      ],
      techContent: {
        cloud: {
          cardLeft: { title: '一心为客户服务', subtitle: '行业标杆' },
          cardRight: { title: '重新定义“体验”的维度', subtitle: '不止于流畅，更在于懂得' },
          intro: '以用户为中心的理念革新，重塑行业体验标准，实现用户满意与业务效率的双重飞跃。',
          advantages: [
            '优质的网站与 app 设计，让您轻松玩转股票市场',
            '多平台无缝衔接，让您畅享交易',
            '专业配套服务，为您的交易保驾护航'
          ]
        },
        order: {
          cardLeft: { title: '美股港股任您挑选', subtitle: '实现股票全球交易' },
          cardRight: { title: '一站集成', subtitle: '最轻松的全球交易体验' },
          intro: '在全球化的业务版图中，我们提供真正意义上的“一点配置，全球交易”能力',
          advantages: [
            '一站式账户管理、资金调配与合规交易体验',
            '让投资者无需跨平台切换，即可自由布局全球优质资产',
            '一个界面同时覆盖美股、港股实时行情与交易，支持快速切换、订单联动'
          ]
        },
        market: {
          cardLeft: { title: '高效后台交易系统', subtitle: '让您掌握先机' },
          cardRight: { title: '硬核配置稳定交易', subtitle: '不会让您错失良机' },
          intro: '我们构建了专为美股、港股及跨境交易优化的高性能系统架构',
          advantages: [
            '在订单处理、行情同步、资金清算等核心环节实现全链路毫秒级响应',
            '助力机构与专业投资者捕捉瞬息即逝的市场机会',
            '赋予您在美股港股市场中超越对手的交易速度与执行能力'
          ]
        },
        funds: {
          cardLeft: { title: '实时行情梳理', subtitle: '呈现市场脉络' },
          cardRight: { title: '多维数据解读', subtitle: '辅助自主判断' },
          intro: '我们为您梳理市场信息，让决策更从容',
          advantages: [
            '跟踪市场动态，清晰展现行业动向',
            '陪伴您的投资过程，持续提供市场观察',
            '助您在纷繁信息中保持清醒，稳步前行'
          ]
        }
      }
    }
  },
  methods: {
    resolveLink(url) {
      if (typeof url === 'string' && url.trim()) {
        return url.trim();
      }
      return this.defaultTradingUrl;
    }
  },
  computed: {
    currentTech() {
      return this.techContent[this.currentTechTab] || this.techContent.cloud
    }
  }
}
</script>

<style scoped>
.hero-banner {
  position: relative;
  height: 40vh;
  min-height: 600px;
  overflow: hidden;
  background:url("@/assets/487585e4e8bd59c74850991ff73e9fe8.jpg");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.banner-content {
  position: absolute;
  top: 50%;
  left: 15%;
  transform: translateY(-50%);
  z-index: 10;
}
.text-content { text-align: left; }
.brand-name {
  font-size: 1.5rem;
  font-weight: 300;
  color: white;
  margin-bottom: 0.5rem;
  letter-spacing: 0.1em;
}
.main-title {
  font-size: 3.5rem;
  font-weight: 700;
  color: white;
  margin-bottom: 2rem;
  letter-spacing: 0.05em;
  line-height: 1.1;
}
.cta-button {
  background: transparent;
  color: white;
  border: 2px solid white;
  padding: 0.75rem 2rem;
  font-size: 1rem;
  font-weight: 500;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s ease;
  letter-spacing: 0.05em;
}
.cta-button:hover {
  background: white;
  color: #1e3a8a;
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
}
@media (max-width: 1024px) {
  .hero-banner { height: 80vh; min-height: 500px; }
  .main-title { font-size: 2.5rem; }
  .banner-content { left: 10%; }
}
@media (max-width: 768px) {
  .hero-banner { height: 70vh; min-height: 400px; }
  .main-title { font-size: 2rem; }
  .brand-name { font-size: 1.2rem; }
  .banner-content { left: 8%; }
  .cta-button { padding: 0.6rem 1.5rem; font-size: 0.9rem; }
}
@media (max-width: 640px) {
  .hero-banner { height: 60vh; min-height: 350px; }
  .main-title { font-size: 1.8rem; }
  .brand-name { font-size: 1rem; }
  .banner-content { left: 5%; }
}

.nav-tab {
  padding: 0.75rem 1rem;
  font-weight: 500;
  color: #6b7280;
  border-bottom: 2px solid transparent;
  transition: all 0.2s;
  position: relative;
  cursor: pointer;
  background: none;
  border: none;
}
.nav-tab.active {
  color: #1f2937;
  border-bottom-color: #1f2937;
}
.nav-tab:hover {
  color: #374151;
}

.tech-card {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 0.75rem;
}
.tech-card-body {
  padding: 1.5rem;
  text-align: center;
}
.tech-title {
  font-size: 1.75rem;
  font-weight: 700;
  color: #ef7c5b;
}
.tech-subtitle {
  margin-top: 0.25rem;
  color: #9ca3af;
}
.advantage-icon-box {
  width: 48px;
  height: 48px;
  min-width: 48px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 2px dashed #ef7c5b;
  border-radius: 12px;
  margin-right: 12px;
  background: #fff7f4;
}
.learn-more-btn {
  background: #ef7c5b;
  color: #ffffff;
  padding: 0.6rem 1.5rem;
  border: none;
  border-radius: 1.5rem;
  font-weight: 600;
}
</style>
